// Okiru's policy pages, hosted on okiru.co.za. One list, used by the app footer,
// the sign-in screen and (mirrored in server.js) the public verification page.
export const LEGAL_LINKS = [
  { label: 'Privacy Policy',       href: 'https://www.okiru.co.za/privacy-policy' },
  { label: 'Terms & Conditions',   href: 'https://www.okiru.co.za/terms-and-conditions' },
  { label: 'Terms of Use',         href: 'https://www.okiru.co.za/terms-of-use' },
  { label: 'Data Deletion',        href: 'https://www.okiru.co.za/data-deletion-policy' },
  { label: 'Sitemap',              href: 'https://www.okiru.co.za/sitemap-page' },
];
